import { RouteDictionary } from '@/modules/common/route/types';

type BuildRouteParams<T extends Record<string, string>> = Readonly<{
  baseName: string;
  indexName: string;
  subRouteNames: T;
}>;

export const buildRoutes = <T extends Record<string, string>>({
  baseName,
  indexName,
  subRouteNames,
}: BuildRouteParams<T>): RouteDictionary<T> => {
  const prefixedName = (name: string): string => `${baseName}-${name}`;
  return Object.fromEntries(
    Object.entries(subRouteNames).map(([routeKey, routeName]) =>
      routeName === indexName ? [routeKey, baseName] : [routeKey, prefixedName(routeName)],
    ),
  ) as RouteDictionary<T>; // TODO: Find a way to avoid this cast
};
